import { cn } from '@lfg/ui/lib';
import { type CheckboxProps, FormControlLabel, FormGroup, Typography } from '@mui/material';
import type { ChangeEvent, ReactNode } from 'react';

import { AdminCheckbox } from './NodeSaleForm/AdminCheckbox';

interface Item {
  label?: string | ReactNode;
  value: string;
  disabled?: boolean;
  readonly?: boolean;
  defaultChecked?: boolean;
}

interface BasicCheckBoxGroup extends Omit<CheckboxProps, 'onChange' | 'value' | 'className'> {
  onChange: (value: string[]) => void;
  value: string[];
  options: Item[];
}
const BasicCheckBoxGroup = (props: BasicCheckBoxGroup) => {
  const { onChange, value, options } = props;

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const checked = e.target.checked;
    const val = e.target.value;
    if (checked) {
      onChange([...value, val]);
    } else {
      onChange(value.filter(v => v !== val));
    }
  };

  const renderLabel = (text: string) => (
    <Typography color='#fff' className='text-body_m font-gotham'>
      {text}
    </Typography>
  );

  return (
    <FormGroup onChange={handleChange} className={cn('grid grid-cols-12 grid-flow-col gap-2')}>
      {(options || []).map(opt => (
        <FormControlLabel
          control={<AdminCheckbox />}
          label={typeof opt.label === 'string' ? renderLabel(opt.label) : opt.label}
          value={opt.value}
          disabled={opt?.disabled || false}
        />
      ))}
    </FormGroup>
  );
};

export default BasicCheckBoxGroup;

BasicCheckBoxGroup.displayName = 'BasicCheckBoxGroup';
